/**
 * Client-side attestation helpers. Wording and active versions come from
 * GET /signing/attestations/active — use `useActiveAttestations` + helpers below.
 */

export type AttestationFamily =
  | 'visit'
  | 'missed_visit'
  | 'order'
  | 'cms485'
  | 'medication'
  | 'communication'
  | 'misc'
  // Not reachable via resolveAttestationFamily — a bypass applies to any
  // task type, so callers select this family directly.
  | 'signature_bypass'
  // Selected directly by the outside-record completion dialog.
  | 'outside_record';

/** Single attestation block (matches API `AttestationContentResponse`). */
export interface SigningAttestation {
  version: string;
  text: string;
}

/** Map returned by GET /signing/attestations/active. */
export type ActiveAttestationsMap = Record<
  AttestationFamily,
  SigningAttestation
>;

export function resolveAttestationFamily(
  taskType: 'visit' | 'order' | 'patient_communication' | 'misc_task',
  orderType?: string | null,
  { isMissedVisit = false }: { isMissedVisit?: boolean } = {}
): AttestationFamily {
  if (taskType === 'visit') return isMissedVisit ? 'missed_visit' : 'visit';
  if (taskType === 'patient_communication') return 'communication';
  if (taskType === 'misc_task') return 'misc';
  if (orderType === 'CMS_485') return 'cms485';
  return 'order';
}

export function selectAttestationForFamily(
  map: ActiveAttestationsMap,
  family: AttestationFamily
): SigningAttestation {
  return map[family];
}
